import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

export default function SelectSignature({ signatures, onSelect, activeTab }) {
    const [selectedId, setSelectedId] = useState(null);

    const handleSelect = (id) => {
        setSelectedId(id);
        onSelect?.(id);
    };

    useEffect(() => {
        setSelectedId(null);
    }, [activeTab]);
    

    const signatureIds = signatures ? Object.keys(signatures) : [];

    if (!signatureIds.length) return <p>No uploaded signatures available.</p>;

    return (
        <div className="p-2">
            <Row className="g-4">
                {signatureIds.map((id) => {
                    const url = signatures[id];
                    return (
                        <Col
                            key={id}
                            xs={6} // 2 per row on extra small screens
                            sm={6} // 3 per row on small screens
                            md={3}   // 4 per row
                            className="d-flex justify-content-centerr"
                        >
                            <img
                                src={url}
                                alt={`Signature ${id}`}
                                data-id={id}
                                onClick={() => handleSelect(id)}
                                className={`rounded border img img-fluid ${
                                    selectedId === id
                                        ? "border-primary border-3"
                                        : "border-secondary"
                                }`}
                                style={{
                                    width: "100%", // fixed width
                                    height: "100px", // fixed height (landscape-friendly)
                                    // objectFit: "contain", // maintain aspect ratio
                                    cursor: "pointer",
                                    transition:
                                        "transform 0.2s, border-color 0.2s",
                                    transform:
                                        selectedId === id
                                            ? "scale(1.05)"
                                            : "scale(1)",
                                }}
                                onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                        "scale(1.05)")
                                }
                                onMouseLeave={(e) =>
                                    (e.currentTarget.style.transform =
                                        selectedId === id
                                            ? "scale(1.05)"
                                            : "scale(1)")
                                }
                            />
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
}
